module.exports = __webpack_public_path__ + "img/2.7a394f09.png";